export const SeeInvoiceText = 'Voir la facture';
